module.exports = __webpack_public_path__ + "img/summary_xl.e03ac831.png";